import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { onUnmounted, ref, watch } from 'vue';

interface OverlayOptions {
  map: google.maps.Map;
  position: () => google.maps.LatLng;
  skewed: boolean;
  div: () => HTMLDivElement;
}

interface Props {
  map: google.maps.Map;
  position: google.maps.LatLng;
  skewed?: boolean;
  fillColor?: string;
  textColor?: string;
  visible?: boolean;
  zIndex: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleMapsOverlay',
  props: {
    map: null,
    position: null,
    skewed: { type: Boolean, default: true },
    fillColor: { default: '#FFFFF' },
    textColor: { default: '#000000' },
    visible: { type: Boolean, default: true },
    zIndex: null
  },
  setup(__props: any) {

const props = __props as { map: google.maps.Map, position: google.maps.LatLng, skewed: boolean, fillColor: string, textColor: string, visible: boolean, zIndex: number }

_useCssVars((_vm, _setup) => ({
  "f6c343bc": (_vm.textColor),
  "7ff3738c": (_vm.fillColor),
  "55ebc384": (_setup.fontSize),
  "a44fa7e8": (_vm.zIndex)
}))

class Overlay extends google.maps.OverlayView {
  options: OverlayOptions;

  constructor(options: OverlayOptions) {
    super();
    this.options = options;
    this.setMap(options.map);
  }

  // eslint-disable-next-line class-methods-use-this
  onAdd(): void {}

  // eslint-disable-next-line class-methods-use-this
  onRemove(): void {}

  draw(): void {
    const div = this.options.div();
    const divPosition = this.getProjection().fromLatLngToContainerPixel(this.options.position());
    let x = divPosition?.x || 0;
    let y = divPosition?.y || 0;
    if (!this.options.skewed) {
      // label is centered on coordinates
      x -= div.offsetWidth / 2;
      y -= div.offsetHeight / 2;
    }

    div.style.left = `${x}px`;
    div.style.top = `${y}px`;
  }
}

/* Props */



/* State */

const fontSize = ref<string>(`${estimateFontSize()}pt`);
const content = ref<HTMLDivElement>();
const overlay = new Overlay({
  map: props.map,
  position: () => props.position,
  skewed: props.skewed,
  div: () => content.value!,
});
/* Lifecycle */

onUnmounted(() => {
  overlay.setMap(null);
});

props.map.addListener('zoom_changed', () => {
  fontSize.value = `${estimateFontSize()}pt`;
});

/* Methods */

function estimateFontSize(): number {
  const zoomLevel = (props.map.getZoom() || 11) - 10;
  return zoomLevel > 0 ? zoomLevel : 1;
}

watch(
  () => props.position,
  () => {
    overlay.draw();
  },
);

return { __sfc: true,Overlay, props, fontSize, content, overlay, estimateFontSize }
}

})